import DialogAvatars from '~/components/dialog/avatars/DialogAvatars.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';

export const useFamilyPlaceHolderUpdateAvatar = (memberId) => {
  const { t } = useI18n();

  const dialog = useDialogStore();

  const updatedEvent = createEventHook<any>();

  const profileLoadFromNetwork = useProfileLoadFromNetwork();

  const update = async (id) => {
    const { error } = await useApiFetch(URI.UpdateFamily, {
      method: 'POST',
      body: {
        members: [
          {
            memberId,
            avatar: id,
          },
        ],
      },
    });
    await profileLoadFromNetwork.run();
    if (error) return false;
    updatedEvent.trigger();
    return true;
  };

  const openWindow = () => {
    dialog.open(DialogAvatars, {
      level: DialogLevel.Info,
      onConfirm: async (id) => {
        dialog.close();
        try {
          const updated = await update(id);
          if (updated) {
            dialog.close();
          } else {
            dialog.open(DialogError, {
              level: DialogLevel.Info,
              iconHeader: 'warning',
              label: t('error.request'),
            });
          }
        } catch (e) {
          globalThis.$logger.warn('error', e);
        }
      },
    });
  };

  return {
    onUpdated: updatedEvent.on,
    openWindow,
  };
};
